<template>
  <b-modal title="Edit client" :visible="true" @ok="myModal = false" @hidden="$emit('hidden')" @hide="stop" ref="editClientModal">
    <template v-if="!gettingDetails">
      <b-form @submit.prevent="editClient()">
        <b-form-group
          label="Name"
          label-for="clientName"
          :label-cols="2"
          :horizontal="true">
          <b-form-input id="clientName" type="text" autocomplete="name" v-model="client.name" @keypress.native="error = null"></b-form-input>
        </b-form-group>
        <b-form-group
          label="Email"
          label-for="clientEmail"
          :label-cols="2"
          :horizontal="true">
          <b-form-input id="clientEmail" type="email" autocomplete="email" v-model="client.email" @keypress.native="error = null"></b-form-input>
        </b-form-group>
        <b-form-group
          label="Phone"
          label-for="clientPhone"
          :label-cols="2"
          :horizontal="true">
          <b-form-input id="clientPhone" type="text" autocomplete="name" v-model="client.phone" @keypress.native="error = null"></b-form-input>
          <button type="submit" hidden/>
        </b-form-group>
      </b-form>
      <transition name="fade">
        <b-alert show variant="danger" style="width: 100%;" v-if="error">{{error.message}}</b-alert>
      </transition>
      <div slot="modal-footer">
        <b-button type="button" variant="success" class="ladda-button" id="edit-button" data-style="expand-right" @click="editClient()"><i class="fa fa-pencil"></i>&nbsp;Save client</b-button>
      </div>
    </template>
    <template v-else>
      <div style="width: inherit; text-align: center;">
        <b-button type="button" variant="warning" class="ladda-button" id="getting-details-button" data-style="zoom-in">Loading</b-button>
      </div>
      <div slot="modal-footer">
        <!-- empty to prevent default footer rendering -->
      </div>
    </template>
  </b-modal>
</template>

<script>
import * as Ladda from 'ladda'
import api from '../../api'
import config from '../../config'

export default {
  name: 'EditClient',
  props: {
    clientID: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      client: {
        name: null,
        email: null,
        phone: null
      },
      editingClient: false,
      editButton: null,
      error: null,
      gettingDetails: true,
      gettingDetailsButton: null
    }
  },
  created: function () {
    api.request('get', config.serverURI + 'clients/' + this.clientID) //retrieve latest client details
      .then(response => {
        this.client.name = response.data.name
        this.client.email = response.data.email
        this.client.phone = response.data.phone
        this.gettingDetails = false
      })
      .catch(error => {
        this.$emit('error')
        this.$refs.editClientModal.hide()
      })
  },
  watch: {
    gettingDetails: function (val, oldVal) {
      if (val === false) {
        this.$nextTick(() => {
          this.editButton = Ladda.create(document.querySelector( '#edit-button' ))
        })
      }
    }
  },
  mounted: function() {
    this.gettingDetailsButton = Ladda.create(document.querySelector( '#getting-details-button' ))
    this.$nextTick(() => {
      setTimeout(() => {
        this.gettingDetailsButton.start()
      }, 200)
    })
  },
  methods: {
    editClient: function() {
      this.editingClient = true
      this.editButton.start()
      api.request('put', config.serverURI + 'clients/' + this.clientID, this.client)
        .then(response => {
          this.editingClient = false
          this.editButton.stop()
          this.$emit('edited',response.data)
          this.$refs.editClientModal.hide()
        })
        .catch(error => {
          this.editingClient = false
          this.editButton.stop()
          if (error.response) {
            this.error = {
              message: error.response.data.error
            }
          } else {
            this.error = {
              message: 'Server error!'
            }
          }
        })
    },
    stop: function(event) { //prevents modal close while waiting for the API response
      if (this.editingClient) event.preventDefault()
    }
  }
}
</script>

<style scoped>
  .fade-enter-active {
    transition: all .8s ease;
  }
  .fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    /* transform: translateX(10px); */
    opacity: 0;
  }
</style>